export const environment = {
  production: true,
  apiUrl: 'https://api-new.autotaxatiepartners.nl',
  application: 'atp-dashboard',
  password: '53FdUOpyUh2zVEQhcEPf',
  // First item will be the default, one entry will hide the field.
  level: ['person', 'company'],

  inruilModuleDomain: 'https://inkoop.autotaxatiepartners.nl',
  inruilModuleAppId: '108',
};